import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Layout, { PageHero } from "@/components/Layout";
import { DECI_PAGE } from "@/content";

const fade = { initial: { opacity: 0, y: 18 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.45 } };

export default function Deci() {
  return (
    <Layout>
      <PageHero crumb={<><Link to="/">Home</Link> / DECI</>} title="DECI" subtitle="Dynamic Electrical Cortical Imaging: brain movies from an ordinary EEG." />

      <section className="section">
        <div className="wrap split">
          <motion.div className="prose" {...fade}>
            <span className="eyebrow">About DECI</span>
            <h2 style={{ marginTop: 14, color: "#fff" }}>A new window into the cortex</h2>
            <p style={{ color: "#fff" }}>{DECI_PAGE.intro}</p>
            <h3 style={{ color: "#fff" }}>How DECI works</h3>
            <p style={{ color: "#fff" }}>{DECI_PAGE.how}</p>
          </motion.div>
          <motion.div className="split-media" {...fade} transition={{ duration: 0.5, delay: 0.1 }}>
            <div className="media-card"><img src="/brand/brain-1.jpg" alt="DECI imaging" /></div>
          </motion.div>
        </div>
      </section>

      <section className="section soft">
        <div className="wrap">
          <span className="eyebrow">Background</span>
          <h2 className="h-sec">Why cortical imaging matters</h2>
          <div className="card-panel prose" style={{ marginTop: 28 }}>
            <p style={{ margin: 0 }}>{DECI_PAGE.background}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <span className="eyebrow">The advantage</span>
          <h2 className="h-sec" style={{ color: "#fff" }}>Five simple advantages over existing technologies</h2>
          <div className="prose" style={{ marginTop: 24, color: "#fff" }}>
            <ul>
              {DECI_PAGE.advantages.map((a, i) => (<li key={i} style={{ color: "#fff" }}>{a}</li>))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section soft">
        <div className="wrap">
          <span className="eyebrow">The science</span>
          <h2 className="h-sec">Accuracy of source localization</h2>
          <div className="card-panel prose" style={{ marginTop: 28 }}>
            <p style={{ margin: 0 }}>{DECI_PAGE.localization}</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
